<template>
  <div class="participant-response__fields-list bg-white">
    <div
      v-for="(answer, index) in participantAnswers"
      :key="index"
      class="d-flex response participant-response__field pt-21 position-relative"
      :class="{
        'bg-f9f9e0': selectedQuestionId && selectedQuestionId === answer.questionId,
        'cursor-pointer': openQueriesToQuestionMap && openQueriesToQuestionMap[answer.questionId]
      }"
      @click="selectField(answer)"
    >
      <!-- Open Query Indicator Yellow Dot -->
      <div class="open-query-indicator-container">
        <span class="open-query-indicator" v-if="openQueriesToQuestionMap && openQueriesToQuestionMap[answer.questionId]" />
      </div>

      <!-- Answers -->
      <div class="pa-20 question-answer-container d-flex">
        <!-- Survey Instruction -->
        <Instruction v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'SurveyInstruction'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :usage="usageAsPerAPI" :activityType="activityType" :selectedLanguageCulture="selectedLanguageCulture" />

        <!-- Custom Scale -->
        <CustomScale v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'CustomScale'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :usage="usageAsPerAPI" :activityType="activityType" :selectedLanguageCulture="selectedLanguageCulture" :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]" @answerChanged="setTempAns" />

        <!-- Image Choice -->
        <ImageChoice
          v-if="(answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'Image') || answer[usageAsPerAPI.QUESTION_TYPE] == 'MultipleChoiceImage'"
          :answer="answer"
          :stepIndex="index"
          :mode="modes[mode]"
          :surveyData="surveyData"
          :usage="usageAsPerAPI"
          :activityType="activityType"
          :selectedLanguageCulture="selectedLanguageCulture"
          :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]"
          @answerChanged="setTempAns"
        />

        <!-- Multiple Choice -->
        <MultiChoice
          v-if="(answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'MultiChoice') || answer[usageAsPerAPI.QUESTION_TYPE] == 'SingleChoice' || answer[usageAsPerAPI.QUESTION_TYPE] == 'MultipleChoice'"
          :answer="answer"
          :stepIndex="index"
          :mode="modes[mode]"
          :surveyData="surveyData"
          :usage="usageAsPerAPI"
          :activityType="activityType"
          :selectedLanguageCulture="selectedLanguageCulture"
          :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]"
          @answerChanged="setTempAns"
        />

        <!-- Number -->
        <Number
          v-if="(answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'Number') || answer[usageAsPerAPI.QUESTION_TYPE] == 'Integer' || answer[usageAsPerAPI.QUESTION_TYPE] == 'Decimal'"
          :answer="answer"
          :stepIndex="index"
          :mode="modes[mode]"
          :surveyData="surveyData"
          :usage="usageAsPerAPI"
          :activityType="activityType"
          :selectedLanguageCulture="selectedLanguageCulture"
          :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]"
          @answerChanged="setTempAns"
        />

        <!-- Number Scale -->
        <NumberScale v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'NumberScale'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :usage="usageAsPerAPI" :activityType="activityType" :selectedLanguageCulture="selectedLanguageCulture" :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]" @answerChanged="setTempAns" />

        <!-- TEXT -->
        <TextResponse v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'Text'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :usage="usageAsPerAPI" :activityType="activityType" :selectedLanguageCulture="selectedLanguageCulture" :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]" @answerChanged="setTempAns" />

        <!-- DROPDOWN -->
        <Dropdown
          v-if="(answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'DropDown') || answer[usageAsPerAPI.QUESTION_TYPE] == 'ValuePicker'"
          :answer="answer"
          :stepIndex="index"
          :mode="modes[mode]"
          :surveyData="surveyData"
          :usage="usageAsPerAPI"
          :activityType="activityType"
          :selectedLanguageCulture="selectedLanguageCulture"
          :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]"
          @answerChanged="setTempAns"
        />

        <!-- VAS -->
        <VAS v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'VAS'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :usage="usageAsPerAPI" :activityType="activityType" :selectedLanguageCulture="selectedLanguageCulture" :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]" @answerChanged="setTempAns" />

        <!-- Boolean -->
        <Boolean v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'Boolean'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :usage="usageAsPerAPI" :activityType="activityType" :selectedLanguageCulture="selectedLanguageCulture" :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]" @answerChanged="setTempAns" />

        <!-- Image Capture -->
        <ImageCapture v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'ImageCapture'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]" @answerChanged="setTempAns" :usage="usageAsPerAPI" :activityType="activityType" />

        <!-- DateTime -->
        <DateTime
          v-if="(answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'DateTime') || answer[usageAsPerAPI.QUESTION_TYPE] == 'Date' || answer[usageAsPerAPI.QUESTION_TYPE] == 'Time'"
          :answer="answer"
          :stepIndex="index"
          :mode="modes[mode]"
          :surveyData="surveyData"
          :usage="usageAsPerAPI"
          :activityType="activityType"
          :selectedLanguageCulture="selectedLanguageCulture"
          :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]"
          @answerChanged="setTempAns"
          :validations="validations"
          :answersLength="participantAnswers.length"
        />

        <!-- GP Skin -->
        <GPSkin v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'GPSkin'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :usage="usageAsPerAPI" :activityType="activityType" :selectedLanguageCulture="selectedLanguageCulture" :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]" />

        <!-- Skin Analyzer -->

        <SkinAnalyzer v-if="answer[usageAsPerAPI.QUESTION_TYPE] && answer[usageAsPerAPI.QUESTION_TYPE] == 'SkinAnalyser'" :answer="answer" :stepIndex="index" :mode="modes[mode]" :surveyData="surveyData" :usage="usageAsPerAPI" :activityType="activityType" :selectedLanguageCulture="activityLanguageCulture" :question="questionDetailsObj[answer[usageAsPerAPI.QUESTION_ID]]" />
      </div>

      <div class="create-query-btn-container" v-if="mode == 'PREVIEW' && (userRoles.canCraAccess || userRoles.canDmAccess || userRoles.canPharmacovigilanceAccess || userRoles.canCraUBAccess)">
        <button class="open-new-query-btn" :class="canCraOpenQuery ? 'disable-open-query-button' : ''" @click.stop="createNewQuery(answer)" :id="`open-query-button-${answer.id}`">Open A Query</button>
        <b-popover v-if="canCraOpenQuery" :target="`open-query-button-${answer.id}`" triggers="hover" placement="bottomright"> You cannot open queries on locked activities. </b-popover>
      </div>
    </div>
  </div>
</template>
<script>
import Instruction from "./activity-steps/instruction-response";
import CustomScale from "./activity-steps/custom-scale-response";
import ImageChoice from "./activity-steps/image-choice-response";
import Dropdown from "./activity-steps/dropdown-response";
import MultiChoice from "./activity-steps/multi-choice-response";
import Boolean from "./activity-steps/boolean-response";
import TextResponse from "./activity-steps/text-response";
import Number from "./activity-steps/number-response";
import NumberScale from "./activity-steps/number-scale-response";
import GPSkin from "./activity-steps/gp-skin-response";
import ImageCapture from "./activity-steps/image-capture-response";
import VAS from "./activity-steps/vas-response";
import DateTime from "./activity-steps/date-time-response";
import SkinAnalyzer from "./activity-steps/skin-analyzer-response";
import localStorageService from "@/services/localStorage";

export default {
  name: "ParticipantSurveyResponsePreview",
  data() {
    return {
      modes: {
        PREVIEW: 0,
        EDIT: 1,
        RESPONSE: 2
      },
      usageAsPerAPI: {}
    };
  },
  props: {
    participantAnswers: Array,
    questionDetailsObj: Object,
    mode: Number,
    validations: Object,
    activityLanguageCulture: String,
    tempEditedAnswers: Object,
    openQueriesToQuestionMap: Object,
    selectedQuestionId: String,
    selectedLanguageCulture: String,
    userRoles: Object,
    surveyData: Object,
    activityType: String,
    lockStatus: String
  },
  components: {
    CustomScale,
    ImageChoice,
    Dropdown,
    MultiChoice,
    Boolean,
    TextResponse,
    Number,
    NumberScale,
    GPSkin,
    ImageCapture,
    VAS,
    DateTime,
    Instruction,
    SkinAnalyzer
  },
  watch: {
    tempEditedAnswers: {
      handler() {
        this.$emit(`answerChanged`, this.tempEditedAnswers);
      },
      deep: true
    },
    mode: {
      handler() {
        if (this.mode == "RESPONSE") {
          this.usageAsPerAPI = {
            QUESTION_TYPE: `question_type`,
            QUESTION_ID: `question_id`,
            QUESTION_TEXT: `question_text`,
            ANSWER_TEXT: `answer_text`,
            DISPLAY_ANSWER_TEXT: `display_answer_text`,
            DISPLAY_QUESTION_TEXT: `display_question_text`
          };
        } else if (this.mode == "EDIT" || this.mode == "PREVIEW") {
          this.usageAsPerAPI = {
            QUESTION_TYPE: `questionType`,
            QUESTION_ID: `questionId`,
            QUESTION_TEXT: `displayQuestionText`,
            ANSWER_TEXT: `answerText`,
            DISPLAY_ANSWER_TEXT: `displayAnswerText`,
            DISPLAY_QUESTION_TEXT: `displayQuestionText`
          };
        }
      },
      immediate: true
    }
  },
  computed: {
    canCraOpenQuery() {
      let userObj = localStorageService.getItem("userObj");
      if (userObj.restrictions !== "" && this.lockStatus && this.lockStatus.toLowerCase() === "locked") {
        return !!userObj.restrictions.includes("activity_response_query.open_locked");
      }
      return false;
    }
  },
  methods: {
    createNewQuery(ques) {
      if (this.canCraOpenQuery) {
        return true;
      }
      this.$emit("openNewQuery", ques.questionId);
      return false;
    },
    setTempAns(ansDetails) {
      this.tempEditedAnswers[ansDetails.questionId] = ansDetails.newAns;
    },
    selectField(question) {
      if (this.openQueriesToQuestionMap && this.openQueriesToQuestionMap[question.questionId]) {
        this.$emit("selectField", question);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.modal-content-box {
  height: 255px;
}
.que-ans-heading {
  height: 50px;
  background-color: #f9f9fb;
  padding-right: 32px;

  .change-reason-text {
    color: #000000;
  }

  &__left,
  &__right {
    height: 100%;
    padding-top: 15px;
  }

  &__left {
    padding-left: 32px;
    width: calc(40% - 32px);
  }

  &__right {
    flex-grow: 1;
    padding-left: 58px;
  }

  &__line {
    width: 2px;
    height: 100%;
    background-color: #ffffff;
  }
}

.create-query-btn-container {
  display: flex;
  align-items: center;
  width: 120px;
  align-self: center;
  border-bottom: 1px solid #efefef;
  position: absolute;
  right: 10px;
  transform: translateY(-50%);
}

.participant-response__fields-list {
  max-height: 88vh;
  overflow: auto;

  .participant-response__field {
    min-height: 80px;

    .open-query-indicator-container {
      width: 30px;
      text-align: center;

      .open-query-indicator {
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        background-color: #f5a623;
      }
    }

    .question-answer-container {
      width: 100%;
      /* width: calc(100% - 64px); */
      flex-basis: calc(100% -64px);
      border-bottom: 1px solid #efefef;
      padding-bottom: 20px;
      padding-right: 50px;

      .question-container {
        .question-container__question-label {
          font-size: 12px;
          font-weight: bold;
        }

        .index-no {
          width: 20px;
        }
      }

      .answer-container {
        width: 50%;
        flex-basis: 65%;
        min-height: 100%;
        padding-left: 32px;

        .answer {
          height: 100%;
        }
      }
    }
  }
}

.save-btn {
  cursor: pointer;
  width: 85px;
  height: 34.2px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #4c8ce4;
}
.save-btn-text {
  width: 83.9px;
  height: 29.7px;
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-edit-btn {
  cursor: pointer;
  width: 85px;
  height: 34.2px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #ffffff;
}

.cancel-edit-btn-text {
  width: 83.9px;
  height: 29.7px;
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.edit-btn-after {
  cursor: pointer;
  width: 83px;
  height: 24px;
  border-radius: 3px;
  border: solid 1px #d7dfeb;
  background-color: #ffffff;
}
.edit-btn-after-text {
  width: 37px;
  height: 19px;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.edit-btn {
  cursor: pointer;
  width: 83px;
  height: 24px;
  border-radius: 3px;
  border: solid 1px #4c8ce4;
  background-color: #4c8ce4;
}
.edit-btn-text {
  width: 37px;
  height: 19px;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.participant-response__img-response {
  width: 90px;
  height: 100px;
}

/* EDIT MDOE */

.image-edit-mode {
  &__checkbox {
    /* background-color: #4c8ce4; */
    left: 5px;
    top: 5px;
    /* width: 15px; */
    /* height: 15px; */
    /* display: flex; */
    /* align-items: center; */

    /* span { */
    /* color: #ffffff; */
    /* font-size: 10px; */
    /* } */
  }

  &__image {
    width: 90px;
    height: 90px;
  }
}

.number-edit-mode {
  width: 50%;
}

.participant-responses-last-empty-div {
  height: 250px;
}

/* MODAL */

.custom-select-modal-title {
  text-align: center;
  height: 50px;
  /* font-family: Robotobold; */
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
.confirm-change {
  cursor: pointer;
  width: 174px;
  height: 38.7px;
  border-radius: 4px;
  border: solid 1px #ffffff;
  background-color: #4c8ce4;
}
.confirm-change-text {
  width: 171.8px;
  height: 33.7px;
  /* font-family: RobotoBold; */
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.custom-select-modal {
  width: 656px;
  height: 278px;
  border-radius: 4px;
  background-color: #ffffff;
}

.custom-select {
  background: #ffffff url(/static/img/arrow-down.png) no-repeat;
  width: 447px;
  height: 40.7px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
}

.save-btn {
  cursor: pointer;
  width: 85px;
  height: 34.2px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #4c8ce4;
}
.save-btn-text {
  width: 83.9px;
  height: 29.7px;
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-confirm-btn {
  cursor: pointer;
  width: 85px;
  height: 34.2px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #ffffff;
}

.cancel-confirm-btn-text {
  width: 83.9px;
  height: 29.7px;
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.open-new-query-btn {
  width: auto !important;
  height: 24px;
  border: 1px solid #d7dfeb;
  font-family: "RobotoRegular";
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c8ce4;
  background-color: #ffffff;
  text-transform: uppercase;
  border-radius: 3px;
  padding: 2px 5px;
  cursor: pointer;
}

/* UTILS */

.bg-f9f9e0 {
  background-color: #f9f9e0;
}
.font-w-bold {
  font-weight: bold !important;
}
.color-black {
  color: #000000;
}
.color-white {
  color: #ffffff;
}
button {
  outline: none;
}
.h-100-percent {
  height: 100%;
}
.index-no {
  width: 20px !important;
}
</style>
